import { Spacing } from "@bonusx-global/bx-design-system";
import { PREVIOUS_URL_PATH, SERVICES_PATH } from "../../../../../constants/env";
import { HeaderV2LayoutAction } from "../../../../../legacy/components/HeaderV2/stores/header-v2-layout-store";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

const BODY_PADDING_BOTTOM_MOBILE = Spacing["2500"];

export class ProductDetailRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      contentLayoutStyles: {
        mobile: {
          paddingBottom: `${BODY_PADDING_BOTTOM_MOBILE} !important`,
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return true;
  }

  getVariantHeaderSettings(): IHeaderV2Store {
    return {
      layoutStore: {
        backButton: {
          url: PREVIOUS_URL_PATH,
          defaultBackUrl: SERVICES_PATH,
        },
        actions: [HeaderV2LayoutAction.aiAssistant, HeaderV2LayoutAction.notification],
        showLogoOnMobile: false,
      },
    };
  }
}
